/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * this class contains additional information for renderer configuration
 */
export class RenderConfig {
    // tslint:disable-next-line:no-any
    constructor(settings) {
        this.enableShadows = false;
        this.enableVR = false;
        this.enableOverlays = true; // TODO : make this settable
        this._parameter = {
            preserveDrawingBuffer: false,
            antialias: true,
            alpha: false,
        };
        // tslint:disable-next-line:no-any
        this.initVR = (renderer) => { document.body.appendChild(WEBVR.createButton(renderer)); };
        if (!!settings) {
            Object.keys(settings).forEach((key) => {
                if (key === 'parameter') {
                    this.setWebGLRendererParameters(settings[key]);
                }
                else {
                    // tslint:disable-next-line:no-any
                    this[key] = settings[key];
                }
            });
        }
    }
    set enableAntialiasing(aa) {
        this._parameter.antialias = aa;
    }
    get enableAntialiasing() {
        return this._parameter.antialias;
    }
    set enableAlpha(alpha) {
        this._parameter.alpha = alpha;
    }
    get enableAlpha() {
        return this._parameter.alpha;
    }
    getWebGLRendererParameters() {
        return this._parameter;
    }
    setWebGLRendererParameters(params) {
        Object.assign(this._parameter, params);
    }
}
//# sourceMappingURL=RenderConfig.js.map